<!--
 * @Author: zl
 * @Date: 2022-03-18 13:54:21
 * @LastEditTime: 2022-05-07 15:20:22
 * @LastEditors: zl
 * @Description: 新增参建单位信息
-->
<template>
	<el-dialog title="新增单位"
			   :visible.sync="dialogShow"
			   width="1200px"
			   :close-on-click-modal="false"
			   v-if="dialogShow"
			   @close="closeDia"
			   center>
		<w-split v-model="splitValue"
				 class="h600">
			<div slot="left"
				 class="left">
				<div class="header-box">
					<div class="left-text">
						<strong>单位列表</strong>
					</div>
					<div class="right-search flex">
						<el-input v-model="unitName"
								  size="small">
							<el-button slot="append"
									   icon="el-icon-search"
									   type="primary"
									   @click="filterUnit(unitName)"></el-button>
						</el-input>
						<el-button type="success"
								   class="ml10 btn-success"
								   icon="el-icon-refresh"
								   size="small"
								   @click="filterUnit('')"></el-button>
					</div>
				</div>
				<vxe-table align="center"
						   border
						   class="mt15"
						   :data="companyObj.table"
						   header-align="center"
						   height="550px"
						   :loading="companyObj.loading"
						   resizable
						   @current-change="rowClick"
						   show-overflow
						   show-header-overflow
						   highlight-current-row
						   highlight-hover-row>
					<vxe-table-column title="序号"
									  type="seq"
									  width="60"></vxe-table-column>
					<vxe-table-column title="单位类型"
									  field="limitName"
									  width="120"></vxe-table-column>
					<vxe-table-column title="单位名称"
									  field="sname"
									  header-align="center"
									  align="left"></vxe-table-column>
				</vxe-table>
			</div>
			<div slot="right"
				 class="right">
				<div class="header-box">
					<div class="left-text">
						<strong>单位用户</strong>
					</div>
					<div class="right-search flex">
						<el-input v-model="personName"
								  size="small">
							<el-button slot="append"
									   icon="el-icon-search"
									   type="primary"
									   @click="getPersonList"></el-button>
						</el-input>
						<el-button type="primary"
								   class="ml10"
								   size="small"
								   @click="selectPerson">确认选择</el-button>
					</div>
				</div>
				<div class="w-table-layout w-table-page">
					<div class="w-table-content">
						<vxe-table align="center"
								   border
								   class="mt15"
								   ref="personTable"
								   :data="personObj.table"
								   header-align="center"
								   height="95%"
								   :loading="personObj.loading"
								   :row-config="{ keyField: 'userId' }"
								   resizable
								   @checkbox-change="checkChange"
								   @checkbox-all="checkAll"
								   show-overflow
								   show-header-overflow>
							<vxe-table-column type="checkbox"
											  width="70"></vxe-table-column>
							<vxe-table-column title="序号"
											  type="seq"
											  width="70"></vxe-table-column>
							<vxe-table-column title="姓名"
											  field="sname"></vxe-table-column>
						</vxe-table>
					</div>
					<div class="w-table-pager">
						<vxe-pager :current-page="personObj.currentPage"
								   :page-size="personObj.pageSize"
								   :total="personObj.total"
								   :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
								   align="center"
								   @page-change="handleCurrentChange"></vxe-pager>
					</div>
				</div>
			</div>
		</w-split>
	</el-dialog>
</template>

<script>
import { getTreeTableList } from 'api/system/sysTenant'
import { getUserTenantTablePageListByTenantId } from 'api/system/sysUserTenant'
export default {
	name: 'AddUnit',
	components: {},
	props: {
		selectData: {
			type: Array,
			default: () => {
				return []
			},
		},
		showUnit: {
			type: Array,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			splitValue: 0.5,
			dialogShow: false,
			unitName: '',
			personName: '',
			companyObj: {
				table: [],
				defaultTable: [],
				loading: false,
			},
			personObj: {
				table: [],
				defaultTable: [],
				loading: false,
				currentPage: 1,
				pageSize: 10,
				total: 0,
			},
			selectTenantId: '',
			selectTenantnName: '',
			selectLimitName: '',
			selectLimitId: '',
			jsUnitId: '',
			jsLimitId: '',
			djUnitId: '',
			djLimitId: '',
			allPerson: [],
			selectPersonList: [],
		}
	},
	created() {
		this.getCompanyList()
		this.selectData.forEach((x) => {
			if (x.limitId == '1382233551767498754') {
				this.jsUnitId = x.tenantId || ''
				this.jsLimitId = x.limitId || ''
			}
			if (x.limitId == '1382233569480044546') {
				this.djUnitId = x.tenantId || ''
				this.djLimitId = x.limitId || ''
			}
		})
		let userList = this.selectData.concat(this.showUnit)
		// 获取目前展示的人，用来回显勾选
		userList.forEach((x) => {
			if (x.userId) {
				this.allPerson.push(x.userId)
			}
			if (x.limitId == '1382233569480044546') {
				this.djUnitId = x.tenantId || ''
				this.djLimitId = x.limitId || ''
			}
		})
	},
	methods: {
		// 获取所有的单位
		getCompanyList() {
			this.companyObj.loading = true
			getTreeTableList({})
				.then((res) => {
					res.data = res.data.map((x) => {
						if (
							x.id != this.jsUnitId &&
							this.jsLimitId == x.limitId
						) {
							x.noShow = true
						}
						if (
							x.id != this.djUnitId &&
							this.djLimitId == x.limitId
						) {
							x.noShow = true
						}
						return x
					})
					this.companyObj.table = res.data.filter((x) => !x.noShow)
					this.companyObj.table = this.$utils.orderBy(
						this.companyObj.table,
						['limitName', 'asc']
					)
					this.companyObj.defaultTable = res.data.filter(
						(x) => !x.noShow
					)
					this.companyObj.loading = false
				})
				.catch(() => {
					this.companyObj.loading = false
				})
		},

		// 筛选查询
		filterUnit(name) {
			if (name == '') {
				this.unitName = ''
				this.companyObj.table = this.$utils.clone(
					this.companyObj.defaultTable,
					true
				)
				return
			}
			let arr = this.$utils.filterTree(
				this.companyObj.table,
				(x) => x.sname.indexOf(name) >= 0
			)
			this.companyObj.table = arr
		},

		// 左侧单位点击触发右侧人员列表接口
		async rowClick({ row }) {
			// 参加单位limitId
			let limitId = '1382233569480044546'
			// 首先判断是不是代建单位
			if (row.limitId == limitId) {
				let list = this.selectPersonList.filter(
					(x) => x.limitId == limitId && x.tenantId != row.id
				)
				if (list.length > 0 && this.djUnitId == '') {
					let status = await this.$deleteConfirm(
						'该项目已有一家代建单位，勾选第二家代建单位后，' +
							'将自动默认取消之前所勾选的代建单位及人员，' +
							'是否确定进行此操作？',
						true
					)
					if (status) {
						this.selectPersonList = this.selectPersonList.filter(
							(x) => x.limitId != limitId
						)
						this.leftHand(row)
					} else {
						this.getCompanyList()
						this.personObj.table = []
						return
					}
				}
			}

			this.leftHand(row)
		},

		// 处理数据
		leftHand(row) {
			this.selectTenantId = row.id
			this.selectTenantnName = row.sname
			this.selectLimitName = row.limitName
			this.selectLimitId = row.limitId
			this.getPersonList()
		},

		// checkbox change事件
		checkChange(data) {
			data.row.isCheck = data.checked
			let rowData = this.$utils.clone(data.row, true)
			if (data.checked) {
				rowData.limitId = this.selectLimitId
				rowData.limitName = this.selectLimitName
				rowData.leaderName = rowData.sname
				rowData.sname = this.selectTenantnName
				this.selectPersonList.push(rowData)
				return
			}
			let _index = this.selectPersonList.findIndex((x) => {
				if (
					x.userId == data.row.userId &&
					x.tenantId == data.row.tenantId
				) {
					return x
				}
			})
			if (_index > -1) {
				this.selectPersonList.splice(_index, 1)
			}
		},

		// checkbox change-all事件
		checkAll(data) {
			this.personObj.table.forEach((x) => {
				x.isCheck = data.checked
			})
			let _index = ''
			if (data.checked) {
				let handData = this.$utils.clone(data.records, true)
				handData.forEach((x) => {
					_index = this.selectPersonList.findIndex((y) => {
						if (x.userId == y.userId && x.tenantId == y.tenantId) {
							return x
						}
					})
					if (_index == -1) {
						x.limitName = this.selectLimitName
						x.limitId = this.selectLimitId
						x.leaderName = x.sname
						x.sname = this.selectTenantnName
						this.selectPersonList.push(x)
					}
				})
				return
			}
			this.personObj.table.forEach((x) => {
				_index = this.selectPersonList.findIndex((y) => {
					if (x.userId == y.userId && x.tenantId == y.tenantId) {
						return x
					}
				})
				if (_index > -1) {
					this.selectPersonList.splice(_index, 1)
				}
			})
		},

		//获取租户用户列表信息
		getPersonList() {
			this.personObj.loading = true
			let param = {
				tenantId: this.selectTenantId,
				current: this.personObj.currentPage,
				size: this.personObj.pageSize,
				sname: this.personName,
			}
			getUserTenantTablePageListByTenantId(param)
				.then((res) => {
					let userList = this.selectData.concat(this.showUnit)
					userList.forEach((x) => {
						let _index = res.data.records.findIndex((y) => {
							if (
								x.tenantId == y.tenantId &&
								x.userId == y.userId
							) {
								return y
							}
						})
						if (_index > -1) {
							res.data.records.splice(_index, 1)
						}
					})
					res.data.records.forEach((x, index) => {
						if (userList[0].adminId == x.userId) {
							res.data.records.splice(index, 1)
						}
					})
					setTimeout(() => {
						this.personObj.loading = false
						this.personObj.table = res.data.records
						this.personObj.total = parseInt(res.data.total)
					}, 200)
				})
				.catch(() => {
					this.personObj.loading = false
				})
		},

		// 分页处理
		handleCurrentChange({ currentPage, pageSize }) {
			this.personObj.currentPage = currentPage
			this.personObj.pageSize = pageSize
			this.getPersonList()
		},

		// 确认选择
		selectPerson() {
			let arr = this.$utils.clone(this.selectPersonList, true)
			if (arr.length == 0) {
				this.$message.warning('至少选择一个用户添加！')
				return
			}
			let list = arr.map((x) => {
				x.limitId = x.limitId
				x.limitName = x.limitName
				x.leaderName = x.leaderName
				x.sname = x.sname
				x.isSelect = this.selectLimitId == this.jsLimitId ? 0 : null
				x.isNewUserId = 1
				return x
			})
			this.$emit('sendPerson', list)
			this.dialogShow = false
		},

		// 关闭
		closeDia() {
			this.$emit('diaclose', false)
		},
	},
	computed: {},
}
</script>
<style lang='less' scoped>
.left,
.right {
	padding: 0 15px;
	height: 100%;
	.header-box {
		display: flex;
		justify-content: space-between;
	}
}
.w-table-layout {
	height: 95%;
}
.h600 {
	height: 600px !important;
}
</style>